import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Award } from "../api";

const awardsSlice = createSlice({
    name: 'awards',
    initialState: { 
        awards: null,
    } as {
        awards: Award[]|null
    },
    reducers: {
        setAwards(state, action: PayloadAction<{ awards: Award[] }>) {
            state.awards = action.payload.awards
        },
    },
});

export const awardsActions = awardsSlice.actions;
export default awardsSlice.reducer;